import dayjs from "dayjs";
import html2pdf from "html2pdf.js";

export const BillPdfDownload = (
  address,
  address1,
  city,
  gstNo,
  userPhone,
  nextInvNo,
  invNo,
  billDate,
  userDetails,
  customerName,
  userName,
  customerMobile,
  barCodeData = [],
  totalAmount = 0,
  totalDisAmt = 0,
  totalNetAmt = 0,
  totalQty = 0,
  base64Images,
  base64QR,
  totalGstData = [],
  ins,
  ins1,
  ins2,
  ins3,
  ins4,
  ins5,
  ins6,
  gstValue,
  cashAmt,
  cardAmt,
  onlineAmt,
  upiAmt,
  creditAmt,
) => {
  const formatNum = (val = 0, dec = 2) =>
    Number(val || 0)
      .toFixed(dec)
      .replace(/\.00$/, "");

  // use the provided base64 image if present, otherwise point to uploaded image path
  const logoSrc = base64Images;
  const logoCode = base64QR;
  // const logoSrc = base64Images ? base64Images : "";
  const logoHtml = logoSrc
    ? `
    <div class="center">
      <img class="logo" src="${logoSrc}" alt="logo" />
    </div>
  `
    : "";

  const logoQR =
    upiAmt > 0
      ? `
    <div class="center">
        <img class="logo" src="${logoCode}" alt="code" />
      </div>
  `
      : "";
  const showValue = (val) =>
    val && val !== "-" && String(val).trim() !== "" && val !== "undefined"
      ? val
      : "-";
  const isValidValue = (val) =>
    val !== null &&
    val !== undefined &&
    val !== "-" &&
    String(val).trim() !== "" &&
    val !== "undefined";

  // build GST summary totals (if needed)
  const totals = totalGstData.reduce(
    (acc, row) => {
      acc.Basic_amt += Number(row.Basic_amt || 0);
      acc.CGST_AMT += Number(row.CGST_AMT || 0);
      acc.SGST_AMT += Number(row.SGST_AMT || 0);
      acc.NET_AMT += Number(row.NET_AMT || 0);
      return acc;
    },
    { Basic_amt: 0, CGST_AMT: 0, SGST_AMT: 0, NET_AMT: 0 },
  );

  // Prepare items HTML rows consistent with your printed layout
  const itemsHtml = barCodeData
    .map((item, index) => {
      const sno = index + 1;
      const code = (item.DesignCode || "").substring(0, 14);
      const qty = item.stock ?? item.QTY ?? 1;
      const rate = Number(item.CPrice ?? 0);
      const discAmt = Number(item.Disamt ?? 0);
      const discPer = Number(item.Disper) > 0 ? Number(item.Disper) : "";
      // offer = selling price per unit (used in printReceipt amount calculation)
      const offer = Number(item.offer ?? item.SellPrice ?? rate);
      const amount = qty * offer;

      // product extra line (HSN, SMCODE, GST)
      // const prodLine = `HSN:${item.HSNCODE || "-"}  SMCODE:${
      //   item?.SMCODE || "-"
      // }  GST:${item?.GST || 0}%`;
      const prodLineParts = [
        item?.HSNCODE && isValidValue(item.HSNCODE)
          ? `HSN:${item.HSNCODE}`
          : null,
        item?.GST && Number(item.GST) > 0 ? `GST:${item.GST}%` : null,
        item?.SMCODE && isValidValue(item.SMCODE) ? `SM:${item.SMCODE}` : null,
        item?.Prodsize && isValidValue(item.Prodsize)
          ? `SZ:${item.Prodsize}`
          : null,
      ].filter(Boolean);

      const prodLine = prodLineParts.join("  ");
      const prodSize = [
        item?.Prodsize && item.Prodsize !== "-" ? `SZ:${item.Prodsize}` : null,
      ].filter(Boolean);

      // MRP and OFFER line
      const mrp = Number(item.CPrice ?? 0).toFixed(2);
      const offerStr = (item?.offer ?? offer).toFixed(2);

      // Limit product name width visually
      const productName = (item.ProdName || item.PRODUCTNAME || "").substring(
        0,
        30,
      );

      return `
        <div class="item-block">
          <div class="item-top">
            <div class="item-left"><b>${sno}</b> &nbsp; <span class="barcode">${code}</span></div>
            <div class="item-right">
              <span class="qty">${qty}</span>
              <span class="rate">${formatNum(rate)}</span>
              <span class="disc">
          ${formatNum(discAmt)}
          ${discPer > 0 ? `<div class="disc-per">${discPer}%</div>` : ""}
        </span>
              <span class="amt">${formatNum(amount)}</span>
            </div>
          </div>

          <div class="item-name">${productName}</div>
          <div class="item-sub">${prodLine}</div>
        </div>
        <div class="divider"></div>
      `;
    })
    .join("\n");

  // build GST table rows
  const gstRowsHtml = totalGstData
    .map((r) => {
      const cgstRate = r.CGST_RATE ?? r.CGST ?? 0;
      const sgstRate = r.SGST ?? 0;
      return `<tr>
        <td class="gcell">${formatNum(r.Basic_amt, 2)}</td>
        <td class="gcell">${cgstRate}%</td>
        <td class="gcell">${formatNum(r.CGST_AMT, 2)}</td>
        <td class="gcell">${sgstRate}%</td>
        <td class="gcell">${formatNum(r.SGST_AMT, 2)}</td>
        <td class="gcell">${formatNum(r.NET_AMT, 2)}</td>
      </tr>`;
    })
    .join("\n");

  const gstSummaryHtml =
    gstValue === true && totalGstData.length > 0
      ? `
    <div>
      <div class="center" style="font-weight:bold; margin-bottom:6px;">GST SUMMARY</div>
       <div class="divider"></div>
      <table class="gst-table">
  <thead>
    <tr>
      <th style="width:14%;">BASIC AMT</th>
      <th style="width:12%;">CGST(%)</th>
      <th style="width:14%;">CGST(AMT)</th>
      <th style="width:12%;">SGST(%)</th>
      <th style="width:14%;">SGST(AMT)</th>
      <th style="width:10%;">NET AMT</th>
    </tr>
  </thead>
  <tbody>
    ${
      gstRowsHtml ||
      `
      <tr>
        <td>0.00</td><td>0%</td><td>0.00</td>
        <td>0%</td><td>0.00</td><td>0.00</td>
      </tr>
    `
    }
  </tbody>
</table>

      <div class="divider"></div>
    </div>
    `
      : "";

  const cashValue =
    cashAmt > 0
      ? `<div class="summary-left1">
        <div class="label1">CASH PAID</div>
        <div class="value1">${formatNum(cashAmt, 2)}</div>
      </div>`
      : "";

  const cardValue =
    cardAmt > 0
      ? `<div class="summary-right-row1">
         <div class="summary-right-label1">CARD PAID</div>
         <div class="summary-right-value1">${formatNum(cardAmt, 2)}</div>
       </div>`
      : "";

  const upiValue =
    upiAmt > 0
      ? `<div class="summary-right-row1">
         <div class="summary-right-label1">UPI PAID</div>
         <div class="summary-right-value1">${formatNum(upiAmt, 2)}</div>
       </div>`
      : "";

  const onlineValue =
    onlineAmt > 0
      ? `<div class="summary-right-row1">
         <div class="summary-right-label1">ONLINE PAID</div>
         <div class="summary-right-value1">${formatNum(onlineAmt, 2)}</div>
       </div>`
      : "";

  const creditValue =
    creditAmt > 0
      ? `<div class="summary-right-row1">
         <div class="summary-right-label1">CREDIT</div>
         <div class="summary-right-value1">${formatNum(creditAmt, 2)}</div>
       </div>`
      : "";

  // HTML template matching thermal receipt layout (80mm)
  const htmlContent = `
  <!doctype html>
  <html>
    <head>
      <meta charset="utf-8"/>
      <title>Tax Invoice</title>
      <style>
        /* Receipt style tuned for 80mm width */
           body {
          font-family: monospace, sans-serif;
          font-size: 12px;
        }
        .center { text-align: center; }
        .logo { display:block; margin: 0 auto 6px auto; max-width: 180px; max-height:120px; object-fit: contain; }
        .logo { display:block; margin: 0 auto 6px auto; max-width: 250px; max-height:150px; object-fit: contain; }
        .store-name { font-size: 20px; letter-spacing: 1px; }
        .small { font-size: 10px; }
        .divider { border-top: 1.5px dashed #000; margin:6px 0; }
        .section { margin-bottom: 4px; }
        .info-row { display:flex; justify-content:space-between;  font-size: 11px; }
        .info-row1 { display:flex; flex-direction:column; }
        .info-left { width: 100%;}
        .info-right { width: 100%; }
        .info-left1 { width: 100%;  font-size: 11px;}
        .info-left-value {font-size: 14px; font-weight:bold;}

        /* Items header */
        .items-header { display:flex; margin-top:4px; }
        .h-left { width: 45%; } /* SNO BARCODE */
        .h-right { width: 55%; text-align:right; display:flex; justify-content:space-between; gap:6px; }

        .item-block { margin-top:6px; }
        .item-top { display:flex; justify-content:space-between; align-items:flex-start; }
        .item-left { width: 47%; word-break: break-word;  }
        .item-right { width: 53%; text-align:right; display:flex; justify-content:space-between;}
        .item-name { font-size:11px; margin-top:4px; padding: 0px 0px 0px 30px;}
        .item-sub { font-size:12px; color:#000; margin-top:2px; padding: 0px 0px 0px 30px;}
        .barcode {font-size:12px; font-weight:bold; border: "#000"; background-color: #000; border-radius: 8px; color: #fff; padding: 3px;}
        .qty {font-size:11px;}
        .rate {font-size:11px; margin-right: 5px;}
        .disc {font-size:11px; margin-right: 15px; line-height: 1.2;}
        .disc-per {
  font-size: 11px;
}
        .amt {font-size:11px;}

       .summary {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
}

/* LEFT SIDE */
.summary-left {
  width: 50%;
  display: flex;
  justify-content: flex-start;
}

.summary-left .label {
  width: 40%;
  text-align: left;
}

.summary-left .value {
  width: 30%;
  text-align: left;
}

/* RIGHT SIDE */
.summary-right {
  width: 50%;
}

.summary-right-row {
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
}

.summary-right-label {
  width: 70%;
  text-align: right;
}

.summary-right-colon {
  width: 5%;
  text-align: center;
}

.summary-right-value {
  width: 30%;
  text-align: right;
}

.summary1 {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
  margin-bottom: 20px;
}

.summary-left1 {
  width: 50%;
  display: flex;
  justify-content: flex-start;
}

.summary-left1 .label1 {
  width: 40%;
  text-align: left;
}

.summary-left1 .value1 {
  width: 30%;
  font-size:12px;
  font-weight:bold;
  border: "#000"; 
  background-color: #000; 
  border-radius: 8px; 
  color: #fff;
  text-align: center;
}

/* RIGHT SIDE */
.summary-right1 {
  width: 50%;
}

.summary-right-row1 {
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
}

.summary-right-label1 {
  width: 70%;
  text-align: right;
}

.summary-right-colon1 {
  width: 5%;
  text-align: center;
}

.summary-right-value1 {
  width: 30%;
  font-size:12px;
  font-weight:bold;
  text-align: center;
  border: "#000"; 
  background-color: #000; 
  border-radius: 8px; 
  color: #fff;
}

.net-bold {
  
  font-size: 14px;
}


        /* GST summary table */
        .gst-table { width: 100%; border-collapse: collapse; font-size: 10px; margin-top:6px; }
        .gst-table th, .gst-table td { padding: 4px 4px; border-bottom: none; text-align: right; font-size:8px; }
        .gst-table th { text-align:left; font-weight:bold; }
        .gcell { text-align:right; min-width: 40px;  font-size:5px; }

        /* Terms */
.terms {
    font-size: 10px;
    margin: 0;
    padding: 0;
    
  }

  .terms div {
    counter-increment: item;
    display: flex;
    gap: 4px;
    padding: 0;
  }

  .gst-table {
  width: 100%;
  border-collapse: collapse;
}

.gst-table thead tr {
  border-bottom: 1px solid #6d6b6bff; /* divider line */
}

.gst-table th,
.gst-table td {
  padding: 3px;
  text-align: right;
}

.gst-table th:last-child,
.gst-table td:last-child {
  border-right: none;
}


        .footer { text-align:center; margin-top:8px; font-size:12px; font-weight:bold; margin-bottom:8px; }
        .open { text-align:left; margin-top:8px; font-size:12px; font-weight:bold; margin-bottom:8px; }

        /* small helpers */
        .muted { font-size: 14px;  color: #000; }
        * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
      </style>
    </head>
    <body>
      <!-- Logo -->
      ${logoHtml}

      <!-- Store name & address -->
      <div class="center store-name">${userName || ""}</div>
      <div class="center muted">${address || ""}</div>
      <div class="center muted">${address1 || ""}</div>
      <div class="center muted">PHONE NO: ${showValue(userPhone) || "-"}</div>
      ${
        isValidValue(gstNo)
          ? `<div class="center muted">GSTIN: ${gstNo}</div>`
          : ""
      }

      <div class="divider"></div>

      <!-- Title -->
      <div class="center" style="font-weight:bold; letter-spacing:1px; font-size: 15px;">${gstValue === true ? "TAX INVOICE" : "BILL OF SUPPLY"}</div>
      <div class="divider"></div>

      <!-- Invoice info -->
      <div class="section">
          
        <div class="info-row1" style="margin-top:4px;">
        <div class="info-left">INV NO : <span class="info-left-value">${
          invNo ? invNo : (nextInvNo ?? "-")
        }</span></div>
          <div class="info-right">DATE : ${
            billDate
              ? dayjs(billDate).format("DD-MMM-YYYY hh:mm A")
              : dayjs().format("DD-MMM-YYYY hh:mm A")
          }</div>
          <div class="info-left1">MOBILE : ${
            showValue(userDetails?.Mobileno) || "-"
          }</div>
          <div class="info-left1">CUST NAME : ${
            showValue(userDetails?.Custname) || "-"
          }</div>
        </div>
      </div>

      <div class="divider"></div>

      <!-- Items header -->
      <div class="items-header">
        <div class="h-left">SNO PARTICULARS</div>
        <div class="h-right"><span>QTY</span><span>RATE</span><span>DISC</span><span>AMOUNT</span></div>
      </div>
      <div class="divider"></div>

      <!-- Items -->
      ${itemsHtml || "<div class='muted'>No items</div>"}

     <div class="summary">

  <!-- LEFT SIDE -->
  <div class="summary-left">
    <div class="label">TOT QTY</div>
    <div class="value">: ${totalQty ?? 0}</div>
  </div>

  <!-- RIGHT SIDE -->
  <div class="summary-right">
    <div class="summary-right-row">
      <div class="summary-right-label">TOTAL AMOUNT</div>
      <div class="summary-right-colon">:</div>
      <div class="summary-right-value">${formatNum(totalAmount, 2)}</div>
    </div>

    <div class="summary-right-row">
      <div class="summary-right-label">DISCOUNT</div>
      <div class="summary-right-colon">:</div>
      <div class="summary-right-value">${formatNum(totalDisAmt, 2)}</div>
    </div>

    <div class="summary-right-row net-bold">
      <div class="summary-right-label">NET AMOUNT</div>
      <div class="summary-right-colon">:</div>
      <div class="summary-right-value">${formatNum(totalNetAmt, 2)}</div>
    </div>
  </div>

</div>


      <div class="divider"></div>
      <!-- GST SUMMARY -->
      ${gstSummaryHtml}

      <div class="summary1">

  <!-- LEFT SIDE -->
  ${cashValue}

  <!-- RIGHT SIDE -->
  <div class="summary-right1">
   ${cardValue}
   ${upiValue}
   ${onlineValue}
   ${creditValue}
  </div>

</div>

      <!-- Terms & Conditions -->
      <div class="center" style="font-size:14px; font-weight:bold; margin-bottom:6px;">****Terms & Conditions****</div>
      <div class="terms">
  <div>${ins}</div>
  <div>${ins1}</div>
  <div>${ins2}</div>
  <div>${ins3}</div>
  <div>${ins4}</div>
  <div>${ins5}</div>
</div>

      ${logoQR}

      <div class="open">PRINT TIME : ${dayjs().format("hh:mm A")}</div>

      <div class="footer">Thank you for shopping please visit again!</div>
    </body>
  </html>
  `;

  // html2pdf options tuned for narrow thermal receipt
  const opt = {
    margin: [0, 0, 0, 0],
    filename: `Invoice_${invNo ? invNo : nextInvNo || "bill"}.pdf`,
    image: { type: "jpeg", quality: 1 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "mm", format: [90, 297], orientation: "portrait" },
  };

  // start download
  html2pdf().from(htmlContent).set(opt).save();
};
